import { Context } from 'lib/api'
import { createContext, useContext } from 'react'

export const UserContext = createContext<Context>(null!)
export const useUserContext = () => useContext(UserContext)
